import React from 'react';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';

export default class CommentEmpty extends Component {
  render() {
    const displayName = 'comment';
    return (
      <div
        style={this.style()}
        className={this.className(bem(displayName, 'empty'))}
        {...getDataAttr(this.props)}>
        {this.props.children || <p>评论列表为空</p>}
      </div>
    );
  }
}
CommentEmpty.defaultProps = {
  children: null,
};

CommentEmpty.propTypes = {
  // @INTRO children
  children: PropTypes.node,
};
